export const APP_CONFIG = {
    IDLE_TIMEOUT: parseInt(process.env.REACT_APP_IDLE_TIMEOUT) || 120000, // 2 minutes default
    TOKEN_REFRESH_INTERVAL: parseInt(process.env.REACT_APP_TOKEN_REFRESH_INTERVAL) || 45000, // 45 seconds default
    LOG_INTERVAL: parseInt(process.env.REACT_APP_LOG_INTERVAL) || 10000, // 10 seconds default
  };
  
  // Log the configuration
  console.log('App configuration:', APP_CONFIG);